module.exports = __webpack_public_path__ + "img/icon-plus-1.b20656a8.svg";